'use strict';

var React = require('react');

var SvgAnalyticsFunnelMinor = function SvgAnalyticsFunnelMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.654 5.77a2 2 0 0 1 1.846-2.77h11a2 2 0 0 1 1.846 2.77l-4.166 10a2 2 0 0 1-1.847 1.23h-2.666a2 2 0 0 1-1.846-1.23l-4.167-10Zm12.846-.77h-11l.833 2h9.334l.833-2Zm-8.5 6-.833-2h7.666l-.833 2h-6Zm.833 2 .834 2h2.666l.834-2h-4.334Z"
  }));
};

exports.SvgAnalyticsFunnelMinor = SvgAnalyticsFunnelMinor;
